import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { scroller } from 'react-scroll';

export const useHandleMobileUrlOnPc = () => {
    const location = useLocation();

    const firstRef = React.useRef(true);

    useEffect(() => {
        if (!firstRef.current) {
            return;
        }

        if (location.pathname.endsWith('/map')) {
            scroller.scrollTo('map', { duration: 0, smooth: false });
        }

        firstRef.current = false;
    }, [location.pathname]);
};
